<template>
  <div>
    <div class="mt-4 mb-4">
      <!--Horaire modal -->
      <b-modal
        :id="modalHoraire"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        size="xl"
        :title="titleModalHoraire"
      >
        <template #default>
          <alert-error
            v-if="formHoraire.errors.get('message')"
            :form="formHoraire"
            :message="formHoraire.errors.get('message')"
          ></alert-error>
          <form
            @submit.prevent="submitHoraire"
            @keydown="formHoraire.onKeydown($event)"
          >
            <div class="row d-flex align-items-center">
              <div class="col-md-8">
                <div class="form-group">
                  <label for="nom"
                    >Nom <span class="text-danger">*</span></label
                  >
                  <input
                    class="form-control"
                    :class="{
                      'is-invalid': formHoraire.errors.has('nom'),
                    }"
                    id="nom"
                    v-model="formHoraire.nom"
                    type="text"
                    placeholder="Titre"
                    maxlength="100"
                    :required="modeHoraire !== 'show'"
                    :disabled="modeHoraire === 'show'"
                  />
                  <has-error :form="formHoraire" field="nom"></has-error>
                </div>
              </div>
              <div class="col-md-2">
                <switches
                  v-if="modeHoraire === 'show'"
                  text-enabled="Statut actif"
                  text-disabled="Statut inactif"
                  :value="formHoraire.statut"
                  type-bold="true"
                  color="custom-primary"
                  class="ml-1 mb-0 font-size-17"
                ></switches>
                <switches
                  v-else
                  text-enabled="Statut actif"
                  text-disabled="Statut inactif"
                  v-model="formHoraire.statut"
                  type-bold="true"
                  color="custom-primary"
                  class="ml-1 mb-0 font-size-17"
                ></switches>
              </div>

              <div class="col-md-2">
                <switches
                  v-if="modeHoraire === 'show'"
                  text-enabled="Par defaut"
                  text-disabled="Pas par defaut"
                  :value="formHoraire.is_default"
                  type-bold="true"
                  color="custom-primary"
                  class="ml-1 mb-0 font-size-17"
                ></switches>
                <switches
                  v-else
                  text-enabled="Par defaut"
                  text-disabled="Pas par defaut"
                  v-model="formHoraire.is_default"
                  type-bold="true"
                  color="custom-primary"
                  class="ml-1 mb-0 font-size-17"
                ></switches>
              </div>

              <!-- <div class="col-md-6">
                <div class="form-group">
                  <label for="date"
                    >Date <span class="text-danger">*</span></label
                  >
                  <date-picker
                    v-model="formHoraire.date"
                    name="date"
                    placeholder="Date"
                    lang="fr"
                    format="DD/MM/YYYY"
                    value-type="DD/MM/YYYY"
                    :required="modeHoraire !== 'show'"
                    :disabled="modeHoraire === 'show'"
                  ></date-picker>
                  <input
                    class="form-control"
                    :class="{
                      'is-invalid': formHoraire.errors.has('date'),
                    }"
                    type="hidden"
                  />
                  <has-error :form="formHoraire" field="date"></has-error>
                </div>
              </div> -->

              <!-- <div class="col-md-12 mt-n4">
                <div class="form-group">
                  <label for="note_description"
                    >Description (max : 500 caractères )
                    <span class="text-danger">*</span></label
                  >
                  <textarea
                    id="note_description"
                    v-model="formHoraire.description"
                    class="form-control"
                    :class="{
                      'is-invalid': formHoraire.errors.has('description'),
                    }"
                    rows="5"
                    maxlength="500"
                    :required="modeHoraire !== 'show'"
                    :disabled="modeHoraire === 'show'"
                  ></textarea>
                  <has-error
                    :form="formHoraire"
                    field="description"
                  ></has-error>
                </div>
              </div> -->

              <div class="px-3 mb-3" v-if="modeHoraire === 'show'">
                <span class="mr-2 text-custom-primary"
                  ><i class="far fa-user text-custom-primary mr-1"></i> Auteur:
                </span>
                <span>{{ formHoraire.auteur }}</span>
              </div>
            </div>

            <div class="row d-flex align-items-center mt-4">
              <div
                v-if="modeHoraire !== 'show'"
                class="col-md-12 d-flex justify-content-end"
              >
                <button
                  type="button"
                  @click.prevent="addItem()"
                  class="btn btn-sm btn-custom-primary mr-2"
                >
                  <i class="fa fa-plus mr-2"></i> Ajouter horaire
                </button>
                <button
                  v-if="horaires.length > 0"
                  type="button"
                  @click.prevent="cancel()"
                  class="btn btn-sm btn-danger"
                >
                  <i class="fa fa-trash mr-2"></i> Annuler tout
                </button>
              </div>
              <div
                v-for="(horaire, i) in horaires"
                :key="horaire.index"
                class="col-12 row"
              >
                <div class="col-md-5">
                  <div class="form-group">
                    <label :for="'jour_semaine' + horaire.index"
                      >Jour de la semaine
                      <span class="text-danger">*</span></label
                    >
                    <v-custom-select
                      label="name"
                      :id="'jour_semaine' + horaire.index"
                      :options="weekdays"
                      :reduce="(d) => d.value"
                      :value="horaire.jour_semaine"
                      placeholder="jour de la semaine"
                      @input="(event) => onDaySelect(horaire, event)"
                      :disabled="modeHoraire === 'show'"
                    >
                      <template v-slot:option="{ name, value }">
                        <h5
                          v-if="isAdded(value)"
                          class="d-flex justify-content-between"
                          style="margin: 0"
                        >
                          <span>{{ name }}</span>
                          <i class="fa fa-thumbs-up text-success"></i>
                        </h5>
                        <h5 v-else class="d-flex" style="margin: 0">
                          <span>{{ name }}</span>
                        </h5>
                      </template>
                      <template #no-options> Aucune données </template>
                      <template #search="{ attributes, events }">
                        <input
                          class="custom-select-height vs__search"
                          v-bind="attributes"
                          v-on="events"
                        />
                      </template>
                    </v-custom-select>
                    <input
                      type="hidden"
                      class="form-control"
                      :class="{
                        'is-invalid': formHoraire.errors.has('jour_semaine'),
                      }"
                    />
                    <has-error
                      :form="formHoraire"
                      :field="`horaires.${i}.jour_semaine`"
                    ></has-error>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="form-group">
                    <label for="heure_debut"
                      >Heure debut <span class="text-danger">*</span></label
                    >
                    <date-picker
                      v-model="horaire.heure_debut"
                      name="heure_debut"
                      placeholder="Heure début"
                      lang="fr"
                      type="time"
                      format="HH:mm"
                      value-type="HH:mm"
                      :required="modeHoraire !== 'show'"
                      :disabled="modeHoraire === 'show'"
                    ></date-picker>
                    <input
                      class="form-control"
                      :class="{
                        'is-invalid': formHoraire.errors.has('heure_debut'),
                      }"
                      type="hidden"
                    />
                    <has-error
                      :form="formHoraire"
                      :field="`horaires.${i}.heure_debut`"
                    ></has-error>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="form-group">
                    <label for="heure_fin"
                      >Heure fin <span class="text-danger">*</span></label
                    >
                    <date-picker
                      v-model="horaire.heure_fin"
                      name="heure_fin"
                      placeholder="heure fin"
                      lang="fr"
                      type="time"
                      format="HH:mm"
                      value-type="HH:mm"
                      :required="modeHoraire !== 'show'"
                      :disabled="modeHoraire === 'show'"
                    ></date-picker>
                    <input
                      class="form-control"
                      :class="{
                        'is-invalid': formHoraire.errors.has('heure_fin'),
                      }"
                      type="hidden"
                    />
                    <has-error
                      :form="formHoraire"
                      :field="`horaires.${i}.heure_fin`"
                    ></has-error>
                  </div>
                </div>
                <div
                  v-if="modeHoraire !== 'show'"
                  class="col-md-1 d-flex align-items-center"
                >
                  <button
                    @click.prevent="removeItem(horaire.index)"
                    type="button"
                    class="btn btn-sm btn-danger mt-2"
                  >
                    <i class="fa fa-minus"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </template>
        <template #modal-footer>
          <button
            type="button"
            class="btn btn-danger mr-2"
            @click="closeModal()"
          >
            Fermer
          </button>

          <button
            v-if="modeHoraire !== 'show'"
            type="submit"
            class="btn btn-custom-primary w-40"
            @click.prevent="submitHoraire"
            style="min-width: 100px"
          >
            {{ modeHoraire === 'create' ? 'Créer' : 'Enregistrer' }}
          </button>
        </template>
      </b-modal>

      <div class="row">
        <div class="col-md-12">
          <div class="row mb-1">
            <div class="col-md-12 text-right">
              <button
                type="button"
                class="btn btn-custom-primary"
                @click="showHoraireModal(null)"
              >
                <i class="fas fa-plus"></i>
                Nouvelles horaires
              </button>

              <button
                type="button"
                class="btn btn-danger ml-4"
                @click.prevent="deleteAllSelectionHoraire"
                v-show="isSelectHoraire"
              >
                <i class="fas fa-trash"></i>
                Supprimer
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <HoraireDataTable
                ref="datatableHoraire"
                @onSelect="onSelectHoraireRows"
                @onRowShow="showHoraireModal"
                @onRowEdit="editHoraireModal"
                @onRowsDelete="deleteHoraireRows"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import URL from '@/http/chantier-horaire';
import CHANTIER_URL from '@/http/chantier';
import HoraireDataTable from './DataTable.vue';
import weekdays from '@/constants/weekdays';
import DatePicker from 'vue2-datepicker';

import From from 'vform';
export default {
  data() {
    return {
      formHoraire: new From({
        nom: '',
        statut: true,
        is_default: false,
      }),
      weekdays: weekdays.weekdays,
      horaires: [],
      jour_semaine: null,
      myIndex: 0,
      currentChantier: null,

      modeHoraire: 'create',
      titleModalHoraire: 'Ajout de nouvelles horaires',
      isSelectHoraire: false,
      modalHoraire: 'modal-horaire',
    };
  },
  components: {
    HoraireDataTable,
    DatePicker,
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  methods: {
    /**
     * Modal note
     */
    async showHoraireModal(id) {
      if (id) {
        this.titleModalHoraire = 'Aperçu des horaires';
        this.formHoraire.reset();
        this.formHoraire.clear();
        this.modeHoraire = 'show';

        await window.axios
          .get(URL.HORAIRE + '/' + id)
          .then((resp) => {
            this.formHoraire.is_default = Boolean(resp.data.horaire.is_default);
            this.formHoraire.nom = resp.data.horaire.nom;
            this.formHoraire.statut = Boolean(resp.data.horaire.statut);
            this.formHoraire.horaires = resp.data.horaire.horaires;
            // Object.assign(this.formHoraire, resp.data.horaire);
            this.horaires = this.formHoraire.horaires.map((h) => ({
              jour_semaine: h.jour_semaine,
              heure_debut: h.heure_debut,
              heure_fin: h.heure_fin,
              index: h.uuid,
            }));
          })
          .catch();
      } else {
        this.modeHoraire = 'create';
        this.titleModalHoraire = 'Ajout de nouvelles horaires';
        this.formHoraire.reset();
        this.formHoraire.clear();
      }

      await this.$bvModal.show(this.modalHoraire);
    },
    async editHoraireModal(id) {
      this.titleModalHoraire = 'Edition des horaires';
      this.formHoraire.reset();
      this.formHoraire.clear();
      this.modeHoraire = 'edit';

      await window.axios
        .get(URL.HORAIRE + '/' + id)
        .then((resp) => {
          // Object.assign(this.formHoraire, resp.data.horaire);
          let data = resp.data.horaire;
          this.formHoraire.id = data.id;
          this.formHoraire.nom = data.nom;
          this.formHoraire.is_default = Boolean(data.is_default);
          this.formHoraire.statut = Boolean(data.statut);
          this.horaires = data.horaires.map((h) => ({
            jour_semaine: h.jour_semaine,
            heure_debut: h.heure_debut,
            heure_fin: h.heure_fin,
            index: h.uuid,
          }));
        })
        .catch();

      await this.$bvModal.show(this.modalHoraire);
    },
    submitHoraire() {
      this.formHoraire.chantier = this.currentChantier.uuid;
      this.formHoraire.horaires = this.horaires.map((h) => ({
        jour_semaine: h.jour_semaine,
        heure_debut: h.heure_debut,
        heure_fin: h.heure_fin,
      }));
      if (this.formHoraire.id) {
        //update
        this.formHoraire
          .put(URL.HORAIRE + '/' + this.formHoraire.id)
          .then((resp) => {
            this.showSimpleAlerte('top-end', 'success', resp.data.message);
            this.$bvModal.hide(this.modalHoraire);
            this.reset();
            this.$refs.datatableHoraire.loadItems();
          })
          .catch((err) => {
            this.formHoraire.errors.set('message', err.response.data.message);
            this.$bvModal.show(this.modalHoraire);
          });
      } else {
        //store
        this.formHoraire
          .post(URL.HORAIRE)
          .then((resp) => {
            this.showSimpleAlerte('top-end', 'success', resp.data.message);
            this.$bvModal.hide(this.modalHoraire);
            this.formHoraire.reset();
            this.formHoraire.clear();
            this.$refs.datatableHoraire.loadItems();
          })
          .catch((err) => {
            this.formHoraire.errors.set('message', err.response.data.message);
            this.$bvModal.show(this.modalHoraire);
          });
      }
    },
    onSelectHoraireRows(isSelectHoraire) {
      this.isSelectHoraire = isSelectHoraire;
    },
    deleteAllSelectionHoraire() {
      this.deleteHoraireRows(this.$refs.datatableHoraire.idsRowsSelected);
    },
    deleteHoraireRows(ids) {
      if (ids && ids.length > 0) {
        this.showConfirmDelete().then((result) => {
          if (result.value) {
            window.axios
              .delete(URL.HORAIRE, {
                params: {
                  ids: ids,
                },
              })
              .then((resp) => {
                this.showSimpleAlerte('top-end', 'success', resp.data.message);
                this.$refs.datatableHoraire.loadItems();
                this.isSelectHoraire = false;
              })
              .catch();
          }
        });
      }
    },

    /** FIN */

    reset() {
      this.formHoraire.reset();
      this.formHoraire.clear();
      this.horaires = [];
      this.myIndex = 0;
    },

    init() {
      let id = this.$route.params.id;
      this.reset();
      window.axios
        .get(CHANTIER_URL.CHANTIER + '/' + id)
        .then((resp) => {
          this.currentChantier = resp.data.chantier;
        })
        .catch(() => {});
    },
    newRow() {},
    cancel() {
      this.horaires = [];
    },
    removeItem(index) {
      let item = this.horaires.find((h) => h.index == index);
      if (item) {
        let i = this.horaires.indexOf(item);
        this.horaires.splice(i, 1);
      }
    },
    isAdded(day) {
      return this.horaires.some((h) => h.jour_semaine === day);
    },
    addItem() {
      if (this.horaires.length < 7)
        this.horaires.push({
          jour_semaine: null,
          heure_debut: null,
          heure_fin: null,
          index: this.myIndex++,
        });
    },
    onDaySelect(h, value) {
      if (!this.isAdded(value)) {
        this.horaires[this.horaires.indexOf(h)].jour_semaine = value;
      }
    },
    submit() {},
    closeModal() {
      this.reset();
      this.$bvModal.hide(this.modalHoraire);
    },
  },
  mounted() {
    this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
      if (modalId === this.modalHoraire) {
        this.reset();
      }
    });
    this.init();
  },
  computed: {},
};
</script>

<style scoped></style>
